<template>
  <div class="studioSet-listMaintain">
    <div class="left-box"
         v-loading="leftLoading">
      <div class="title">
        <span>标签</span>
        <div class="addBtn">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-plus"
                     :disabled="module_id_array[0] ? !module_id_array.includes('1578') : false"
                     @click="editOrAddLabelBtn(1)"></el-button>
        </div>
      </div>

      <div class="label-item"
           v-for="(item,index) in leftListLabel"
           :key="item.label_id"
           @click="clickLabel(item)">
        <div :class="labelBannerForm.label_id == item.label_id ? 'label-name is-check' : 'label-name' ">{{item.label_title}}</div>
        <div class="label-btn">
          <el-link :underline="false"
                   icon="el-icon-edit"
                   :disabled="module_id_array[0] ? !module_id_array.includes('1578') : false"
                   @click.stop="editOrAddLabelBtn(2,item)"></el-link>
          <el-link :underline="false"
                   icon="el-icon-top"
                   :disabled="module_id_array[0] ? !module_id_array.includes('1580') : false"
                   @click.stop="updateLabelSort(1,index)"></el-link>
          <el-link :underline="false"
                   icon="el-icon-bottom"
                   :disabled="module_id_array[0] ? !module_id_array.includes('1580') : false"
                   @click.stop="updateLabelSort(2,index)"></el-link>
          <el-link :underline="false"
                   icon="el-icon-delete"
                   :disabled="module_id_array[0] ? !module_id_array.includes('1579') : false"
                   @click.stop="delLabelBtn(item.label_id)"></el-link>
        </div>
      </div>
    </div>
    <div class="right-box"
         v-if=" labelBannerForm.label_id != ''">
      <div class="bannerBtn">
        <el-button type="primary"
                   size="small"
                   :disabled="module_id_array[0] ? !module_id_array.includes('1582') : false"
                   @click="addOrEditBannerBtn(-1)">添加</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table ref="doctorTableRef"
                  class="doctor-table"
                  v-loading="tableLoading"
                  :data="labelBannerData"
                  tooltip-effect="dark"
                  style="width: 100%; min-width: 1000px"
                  :header-cell-style="{ background: '#F5F5F5' }">
          <el-table-column v-for="item in tableHeader"
                           align="center"
                           :key="item.prop"
                           :label="item.label"
                           :prop="item.prop"
                           :width="item.width"
                           :fixed="item.fixed">
            <template slot-scope="scope">
              <div v-if="item.prop == 'image_str'">
                <el-image style="width: 100px; height: 100px"
                          :src="scope.row[item.prop]"
                          :preview-src-list="[scope.row[item.prop]]">
                </el-image>
              </div>
              <div v-else-if="item.prop == 'min_type'">
                {{ scope.row[item.prop] | minTypeText }}
              </div>
              <div v-else-if="item.prop == 'desc'">
                <el-tooltip class="item"
                            effect="dark"
                            :content="scope.row[item.prop]"
                            placement="top">
                  <div class="text-ellipsis">{{scope.row[item.prop]}}</div>
                </el-tooltip>
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>

          <el-table-column label="排序"
                           width="200px"
                           align="center">
            <template slot-scope="scope">
              <el-tooltip class="item"
                          effect="dark"
                          content="置顶"
                          placement="top">
                <el-button @click="updateBannerSort(scope.$index, 1)"
                           size="medium"
                           type="text"
                           icon="el-icon-upload2"
                           :disabled="module_id_array[0] ? !module_id_array.includes('1585'): false "
                           style="font-size: 20px"></el-button>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="置底"
                          placement="top">
                <el-button @click="updateBannerSort(scope.$index, 2)"
                           size="medium"
                           type="text"
                           icon="el-icon-download"
                           :disabled="module_id_array[0] ? !module_id_array.includes('1585') : false"
                           style="font-size: 20px"></el-button>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="上移"
                          placement="top">
                <el-button @click="updateBannerSort(scope.$index, 3)"
                           size="medium"
                           type="text"
                           icon="el-icon-top"
                           :disabled="module_id_array[0] ? !module_id_array.includes('1585') : false "
                           style="font-size: 20px"></el-button>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="下移"
                          placement="top">
                <el-button @click="updateBannerSort(scope.$index, 4)"
                           size="medium"
                           type="text"
                           icon="el-icon-bottom"
                           :disabled="module_id_array[0] ? !module_id_array.includes('1585') : false"
                           style="font-size: 20px"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="操作"
                           width="140px"
                           align="center"
                           fixed='right'>
            <template slot-scope="scope">
              <el-button @click="addOrEditBannerBtn(scope.row)"
                         type="text"
                         :disabled="module_id_array[0]? !module_id_array.includes('1583'): false"
                         size="medium">编辑</el-button>
              <el-button @click="delBannerBtn(scope.row.banner_id)"
                         type="text"
                         :disabled="module_id_array[0]? !module_id_array.includes('1584'): false"
                         size="medium">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>
    <!-- 添加标签 -->
    <el-dialog :title="labelVisibleTitle"
               width="400px"
               center
               :visible.sync="labelVisible">
      <div style="padding:10px">
        <el-form :model="labelVisibleForm"
                 ref="labelVisibleFormRef"
                 :rules="rules"
                 label-width="70px">
          <el-form-item label="标签名"
                        prop="label_title">
            <el-input v-model="labelVisibleForm.label_title"
                      size="small"
                      maxlength="6"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="labelVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="comfirmLabel('labelVisibleFormRef')">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加Banner -->
    <el-dialog :title="`${isEdit ? '编辑' : '添加 '}Banner`"
               :visible.sync="bannerVisible"
               width="700px"
               :close-on-click-modal="false"
               custom-class="cus-ListMaintain">
      <div style="text-align:left;padding:20px">
        <el-form :model="labelBannerForm"
                 :rules="rules"
                 ref="bannerVisibleRef"
                 label-width="100px"
                 class="ListMaintain-ruleForm">
          <div class="cases-box">
            <el-form-item label="标题"
                          prop="title"
                          class="title">
              <el-input v-model="labelBannerForm.title"
                        size="small"
                        clearable
                        maxlength="50"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="banner"
                          prop="image"
                          class="main-img">
              <UploadImg :f_thumb="labelBannerForm.image"
                         :f_thumb_str="labelBannerForm.image_str"
                         @emitImg="emitMainImg"></UploadImg>
              <div class="prompt">建议尺寸662*358px</div>
            </el-form-item>

            <el-form-item label="类型"
                          prop="min_type">
              <el-select v-model="labelBannerForm.min_type"
                         size="small">
                <el-option v-for="item in typeOptions"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-if="labelBannerForm.min_type"
                          label="APP链接"
                          prop="link_url">
              <el-input v-model="labelBannerForm.link_url"
                        size="small"
                        clearable
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item v-if="labelBannerForm.min_type"
                          label="小程序链接"
                          prop="applet_link_url">
              <el-input v-model="labelBannerForm.applet_link_url"
                        size="small"
                        clearable
                        placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="介绍说明"
                          prop="desc"
                          class="desc-form-item">
              <el-input v-model="labelBannerForm.desc"
                        size="small"
                        clearable
                        maxlength="500"
                        type="textarea"
                        :rows="6"
                        placeholder="请输入"></el-input>
            </el-form-item>

          </div>

        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="bannerVisible=false"
                   size="medium"
                   plain>取 消</el-button>
        <el-button type="primary"
                   size="medium"
                   @click="bannerVisibleConfirm('bannerVisibleRef')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import department from '@/api/department.js';
import UploadImg from '@/components/uploadImg/index';
export default {
  components: {
    UploadImg
  },
  data() {
    const validateMainImg = (rule, value, callback) => {
      if (value === '' || !value) {
        callback(new Error('请上传图片'));
      } else {
        callback();
      }
    };
    return {
      leftLoading: false,
      leftListLabel: [],
      labelVisible: false,
      labelVisibleTitle: '添加标签',
      labelVisibleForm: {
        label_id: '',
        list_id: '',
        label_title: ''
      },
      rules: {
        title: [{ required: true, message: '请输入', trigger: 'blur' }],
        image: [
          { required: true, validator: validateMainImg, trigger: 'blur' }
        ],
        min_type: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        link_url: [
          { required: true, message: '请输入链接/路由', trigger: 'blur' }
        ],
        applet_link_url: [
          { required: true, message: '请输入链接/路由', trigger: 'blur' }
        ],
        desc: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      labelBannerForm: {
        label_id: '',
        title: '',
        image: '',
        image_str: '',
        min_type: 0,
        link_url: '',
        desc: '',
        applet_link_url: ''
      },
      tableHeader: [
        {
          label: '标题',
          prop: 'title',
          width: 'auto'
        },
        {
          label: 'banner',
          prop: 'image_str',
          width: 'auto'
        },
        {
          label: '介绍说明',
          prop: 'desc',
          width: '200'
        },
        {
          label: '操作类型',
          prop: 'min_type',
          width: 'auto'
        },
        {
          label: 'App链接',
          prop: 'link_url',
          width: 'auto'
        },
        {
          label: '小程序链接',
          prop: 'applet_link_url',
          width: 'auto'
        }
      ],
      labelBannerData: [],
      bannerVisible: false,
      isEdit: false,
      typeOptions: [
        {
          label: '原生路由',
          value: 1
        },
        {
          label: '跳转链接',
          value: 2
        },
        {
          label: '无操作',
          value: 0
        }
      ]
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:ss');
    },
    minTypeText(val) {
      switch (val) {
        case 0:
          return '无动作';
        case 1:
          return '原生路由';
        case 2:
          return '跳转链接';
        default:
          return val;
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getFamousDoctorListLabel();
  },
  methods: {
    // 获取标签列表
    getFamousDoctorListLabel() {
      this.leftLoading = true;
      department
        .getFamousDoctorListLabel()
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.leftListLabel = data.list;
            this.labelVisibleForm.list_id = this.$route.query.list_id;
          }
          this.leftLoading = false;
        })
        .catch((err) => {
          this.leftLoading = false;
        });
    },
    // 编辑/添加标签
    editOrAddLabelBtn(type, item) {
      switch (type) {
        case 1:
          this.labelVisibleTitle = '添加标签';
          this.labelVisibleForm.label_title = '';
          this.labelVisibleForm.label_id = '';
          break;
        case 2:
          this.labelVisibleTitle = '编辑标签';
          this.labelVisibleForm.label_title = item.label_title;
          this.labelVisibleForm.label_id = item.label_id;
          break;
      }

      this.labelVisible = true;
    },
    // 确认标签
    comfirmLabel(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.labelVisibleForm);

          department.saveFamousDoctorListLabel(params).then((res) => {
            let { code } = res;
            if (code === 0) {
              this.labelVisible = false;
              this.$message.success('操作成功');
              this.getFamousDoctorListLabel();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 标签排序
    updateLabelSort(type, index) {
      if (this.leftListLabel.length == 1) {
        this.$message.warning('只有一条数据哦');
        return;
      }
      let data = this.leftListLabel[index];
      this.leftListLabel.splice(index, 1);
      //上移
      if (type == 1) {
        let i = !index ? this.leftListLabel.length : index - 1;
        this.leftListLabel.splice(i, 0, data);
      }
      //下移
      if (type == 2) {
        let i = index == this.leftListLabel.length ? 0 : index + 1;
        this.leftListLabel.splice(i, 0, data);
      }
      let list = [];
      list = this.leftListLabel.map((item, index) => {
        item = _.pick(item, ['label_id', 'sort']);
        item.sort = index;
        return item;
      });
      department.sortFamousDoctorListLabel({ list }).then((res) => {
        if (res.code == 0) {
          this.getFamousDoctorListLabel();
        }
      });
    },
    // 删除标签
    delLabelBtn(label_id) {
      this.$confirm(
        '删除标签后，标签将不会在客户端展示，确认需要删除吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          const loading = this.$loading();
          department
            .deleteFamousDoctorListLabel({ label_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.getFamousDoctorListLabel();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    /**** 标签Banner --- start ****/
    // 点击标签
    clickLabel(item) {
      this.labelBannerForm.label_id = item.label_id;
      this.getFamousDoctorListLabelBanner();
    },
    // 添加/编辑banner
    addOrEditBannerBtn(row) {
      if (row != -1) {
        this.labelBannerForm.banner_id = row.banner_id;
        let data = _.pick(row, [
          'title',
          'image',
          'image_str',
          'min_type',
          'link_url',
          'applet_link_url',
          'desc'
        ]);
        this.labelBannerForm = Object.assign(this.labelBannerForm, data);
        this.isEdit = true;
      } else {
        this.isEdit = false;
        for (let key in this.labelBannerForm) {
          if (key != 'label_id') {
            if (key == 'min_type') {
              this.labelBannerForm[key] = 0;
            } else {
              this.labelBannerForm[key] = '';
            }
          }
        }
      }
      this.bannerVisible = true;
    },
    // 获取标签banner
    getFamousDoctorListLabelBanner() {
      let params = {
        label_id: this.labelBannerForm.label_id
      };
      this.tableLoading = true;
      department
        .getFamousDoctorListLabelBanner(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.labelBannerData = data.list;
          }
          this.tableLoading = false;
        })
        .catch((err) => (this.tableLoading = false));
    },
    // 删除banner
    delBannerBtn(banner_id) {
      this.$confirm('确认需要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const loading = this.$loading();
          department
            .deleteFamousDoctorListLabelBanner({ banner_id })
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.getFamousDoctorListLabelBanner();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {});
    },
    // banner排序
    updateBannerSort(index, type) {
      if (this.labelBannerData.length == 1) {
        this.$message.warning('只有一条数据哦');
        return;
      }
      let data = this.labelBannerData[index];
      this.labelBannerData.splice(index, 1);
      //置顶
      if (type == 1) {
        this.labelBannerData.splice(0, 0, data);
      }
      //置底
      if (type == 2) {
        this.labelBannerData.push(data);
      }
      //上移
      if (type == 3) {
        this.labelBannerData.splice(index - 1, 0, data);
      }
      //下移
      if (type == 4) {
        this.labelBannerData.splice(index + 1, 0, data);
      }
      let list = [];
      list = this.labelBannerData.map((item) => {
        item = _.pick(item, ['banner_id', 'sort']);
        return item;
      });
      department.sortFamousDoctorListLabelBanner({ list }).then((res) => {
        if (res.code == 0) {
          this.getFamousDoctorListLabelBanner();
        }
      });
    },
    // 上传图片
    emitMainImg(data) {
      this.labelBannerForm.image = data.pic;
      this.labelBannerForm.image_str = data.path;
      this.$refs['bannerVisibleRef'].validateField(['image']);
    },
    bannerVisibleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.labelBannerForm);
          let interfaceName = 'addFamousDoctorListLabelBanner';
          if (this.isEdit) {
            interfaceName = 'updateFamousDoctorListLabelBanner';
          } else {
            interfaceName = 'addFamousDoctorListLabelBanner';
          }
          const loading = this.$loading();
          department[interfaceName](params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success(`${this.isEdit ? '编辑' : '添加'}成功`);
                this.bannerVisible = false;
                this.getFamousDoctorListLabelBanner();
              }
              loading.close();
              this.styleAndContentVisible = false;
            })
            .catch((err) => {
              loading.close();
              this.styleAndContentVisible = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
    /**** 标签Banner --- end ****/
  }
};
</script>
<style lang="scss" scoped >
.studioSet-listMaintain {
  display: flex;
  // align-items: center;
  justify-content: space-between;
  .left-box {
    width: 320px;
    border: 1px solid #797979;
    box-sizing: border-box;
    min-height: calc(100vh - 140px);
    .title {
      line-height: 40px;
      font-size: 16px;
      font-weight: bold;
      background-color: #f2f2f2;
      margin-bottom: 4px;
      position: relative;
      .addBtn {
        position: absolute;
        right: 3px;
        top: -1px;
      }
    }
    .label-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #f2f2f2;
      margin-bottom: 4px;
      line-height: 40px;
      padding: 0 10px;
      cursor: pointer;
      .label-btn {
        width: 96px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        opacity: 0;
        ::v-deep i {
          font-size: 20px;
        }
      }
    }
    .label-item:hover {
      .label-btn {
        opacity: 1;
      }
    }
    .is-check {
      color: #669961;
      font-weight: bold;
    }
  }
  .right-box {
    width: calc(100% - 320px);
    min-height: calc(100vh - 140px);
    box-sizing: border-box;
    padding: 0 20px;
    .bannerBtn {
      text-align: left;
      margin-bottom: 10px;
      line-height: 40px;
    }
  }
}
</style>

<style lang="scss" scoped>
.cus-ListMaintain {
  .ListMaintain-ruleForm {
    .title {
      ::v-deep .el-form-item__content {
        height: 60px;
      }
    }
    .main-img {
      ::v-deep .el-form-item__content {
        height: 140px;
      }
    }
    .desc-form-item {
      ::v-deep .el-form-item__content {
        height: 140px;
      }
    }
  }
}
</style>